export const SITE = {
    name: "Atlanta Enclave",
    domain: "https://atlantaenclave.com",
    phoneDisplay: "+91 88798 56585",
    phoneTel: "tel:+918879856585",
    whatsappRaw: "https://wa.me/918879856585",
    whatsapp:
        "https://wa.me/918879856585?text=" +
        encodeURIComponent(
            "Hi, I am interested in Atlanta Enclave Shilphata. Please share the latest price, floor plans and availability."
        ),
    rera: "P51700077788",
    reraPortal: "https://maharera.mahaonline.gov.in",
    address:
        "Atlanta Enclave, Opp. Dutta Mandir, Kalyan Shilphata, Mumbai-Pune Road, Thane – 400612",
};

export const img = (name) => `/assets/img/${name}.webp`;

export const openEnquiry = () => window.dispatchEvent(new CustomEvent("ae:enquire"));
